const errorMessage = 'This field is required';
export const BLANK_TIME = 'BLANK';
const isRequired = previewEntry => {
  const {
    value,
    required
  } = previewEntry;
  if (required && (value == BLANK_TIME || value === null)) {
    return errorMessage;
  }
};
export default [{
  validation: isRequired,
  type: 'required'
}];